/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {_ROUTER_CONFIG as ɵa,_createRouterConfig as ɵb} from './src/router_store_module';